import { render, staticRenderFns } from "./list.vue?vue&type=template&id=34035985&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34035985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34035985')) {
      api.createRecord('34035985', component.options)
    } else {
      api.reload('34035985', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=34035985&scoped=true", function () {
      api.rerender('34035985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tutorial/list.vue"
export default component.exports